import { HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {
  DevExtremeModule,
  DxButtonModule,
  DxCalendarModule,
  DxCheckBoxModule,
  DxContextMenuModule,
  DxDataGridModule,
  DxDateBoxModule,
  DxDropDownBoxModule,
  DxFormModule,
  DxFileUploaderModule,
  DxLoadPanelModule,
  DxLookupModule,
  DxNumberBoxModule,
  DxPopupModule,
  DxRadioGroupModule,
  DxSchedulerModule,
  DxScrollViewModule,
  DxSelectBoxModule,
  DxTabsModule,
  DxTagBoxModule,
  DxTemplateModule,
  DxTextAreaModule,
  DxTextBoxModule,
  DxTreeListModule,
  DxPopoverModule
} from 'devextreme-angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {
  SideNavInnerToolbarModule,
  SideNavOuterToolbarModule,
  SingleCardModule,
} from './layouts';

import { FooterModule, LoginFormModule } from './shared/components';
import { AppInfoService, AuthService, ScreenService } from './shared/services';

import { DxoPositionModule } from 'devextreme-angular/ui/nested';
import { PdfZaDostavniceService } from 'src/app/pdf-ovi/pdfZaDostavnice.service';
import { PdfZaOtpremniceService } from 'src/app/pdf-ovi/pdfZaOtpremnice.service';
import { PdfZaOtpremnicePekarTomoService } from 'src/app/pdf-ovi/pdfZaOtpremnicePekarTomo.service';
import { PdfZaPrimkeService } from './pdf-ovi/pdfZaPrimke.service';
import { PrintService } from './pdf-ovi/pdfUFA.service';
import { DeklaracijeComponent } from './pages/deklaracije/deklaracije.component';
import { DjelatniciComponent } from './pages/djelatnici/djelatnici.component';
import { djelatnikPravaComponent } from './pages/djelatnici/djelatnikPrava.component';
import { DnevniPlanComponent } from './pages/dnevni-plan/dnevni-plan.component';
import { DokumentiComponent } from './pages/dokumenti/dokumenti.component';
import { DostavnicaHladComponent } from './pages/dostavnica-hlad/dostavnica-hlad.component';
import { DostavnicaComponent } from './pages/dostavnica/dostavnica.component';
import { IspisPlanaComponent } from './pages/ispis-plana/ispis-plana.component';
import { IzdatniceSirovinaComponent } from './pages/izdatnice-sirovina/izdatnice-sirovina.component';
import { IzvjestajZavrsenihRnComponent } from './pages/izvjestaj-zavrsenih-rn/izvjestaj-zavrsenih-rn.component';
import { KapacitetLinijaComponent } from './pages/kapacitet-linija/kapacitet-linija.component';
import { LotNaljepniceComponent } from './pages/lot-naljepnice/lot-naljepnice.component';
import { NaruceneKolicineGrupeComponent } from './pages/narucene-kolicine-grupe/narucene-kolicine-grupe.component';
import { NaruceneKolicineComponent } from './pages/narucene-kolicine/narucene-kolicine.component';
import { NarudzbeComponent } from './pages/narudzbe/narudzbe.component';
import { OstvareniSatiComponent } from './pages/ostvareni-sati/ostvareni-sati.component';
import { OtpremnicaComponent } from './pages/otpremnica/otpremnica.component';
import { PartneriComponent } from './pages/partneri/partneri.component';
import { PlanProizvodnjeComponent } from './pages/plan-proizvodnje/plan-proizvodnje.component';
import { PlanskaKalkulacijaComponent } from './pages/planska-kalkulacija/planska-kalkulacija.component';
import { PregledIzdatniceComponent } from './pages/pregled-izdatnice/pregled-izdatnice.component';
import { PregledLotoviComponent } from './pages/pregled-lotovi/pregled-lotovi.component';
import { PrimkeComponent } from './pages/primke/primke.component';
import { ProcesiComponent } from './pages/procesi/procesi.component';
import { ProizvodiAkcijaComponent } from './pages/proizvodi-akcija/proizvodi-akcija.component';
import { RasporedLjudiComponent } from './pages/raspored-ljudi/raspored-ljudi.component';
import { RokovitrajanjaComponent } from './pages/rokovitrajanja/rokovitrajanja.component';
import { SifarnikProcesiComponent } from './pages/sifarnik-procesi/sifarnik-procesi.component';
import { SifarnikProizvodiComponent } from './pages/sifarnik-proizvodi/sifarnik-proizvodi.component';
import { SignalniLagerComponent } from './pages/signalnilager/signalnilager.component';
import { SkladisteHladComponent } from './pages/skladiste-hlad/skladiste-hlad.component';
import { SkladisteComponent } from './pages/skladiste/skladiste.component';
//new
import { StanjeSkladistaComponent } from './pages/stanje-skladista/stanje-skladista.component';
import { StrojeviComponent } from './pages/strojevi/strojevi.component';
import { UlazSirovinaComponent } from './pages/ulaz-sirovina/ulaz-sirovina.component';
import { UredjajiComponent } from './pages/uredjaji/uredjaji.component';
import { WebappComponent } from './pages/webapp/webapp.component';
import { ZahtjeviZaSirovineComponent } from './pages/zahtjevi-za-sirovine/zahtjevi-za-sirovine.component';
import { RadniNaloziDokumentiComponent } from './pages/radni-nalozi-dokumenti/radni-nalozi-dokumenti.component';
import { PregledIzdatniceTrosakComponent } from './pages/pregled-izdatnice-trosak/pregled-izdatnice-trosak.component';
import { PregledIzdatnicePotrosnogMaterijalaComponent } from './pages/pregled-izdatnice-potrosnog-materijala/pregled-izdatnice-potrosnog-materijala.component';
import { UfeComponent } from './pages/UFA/ufe/ufe.component';
import { UfaComponent } from './pages/UFA/ufa/ufa.component';
import { DigitalnaPlocaComponent } from './pages/digitalna-ploca/digitalna-ploca.component';
import { PregledReversComponent } from './pages/pregled-revers/pregled-revers.component';
import { MeduskladisnicaComponent } from './pages/meduskladisnica/meduskladisnica.component';
import { MeduskladisnicaMrviceComponent } from './pages/meduskladisnica-mrvice/meduskladisnica-mrvice.component';
import { KarticaArtiklaComponent } from './pages/kartica_artikla/kartica_artikla.component';

@NgModule({
  declarations: [
    AppComponent,
    PlanProizvodnjeComponent,
    KapacitetLinijaComponent,
    NaruceneKolicineComponent,
    PartneriComponent,
    DnevniPlanComponent,
    SkladisteComponent,
    StanjeSkladistaComponent,
    DeklaracijeComponent,
    PregledLotoviComponent,
    DostavnicaHladComponent,
    SkladisteHladComponent,
    RasporedLjudiComponent,
    PlanskaKalkulacijaComponent,
    ProcesiComponent,
    StrojeviComponent,
    SifarnikProcesiComponent,
    SifarnikProizvodiComponent,
    ProizvodiAkcijaComponent,
    DjelatniciComponent,
    IzvjestajZavrsenihRnComponent,
    ZahtjeviZaSirovineComponent,
    PregledIzdatniceComponent,
    DostavnicaComponent,
    IspisPlanaComponent,
    OstvareniSatiComponent,
    NaruceneKolicineGrupeComponent,
    djelatnikPravaComponent,
    DokumentiComponent,
    PrimkeComponent,
    IzdatniceSirovinaComponent,
    UlazSirovinaComponent,
    LotNaljepniceComponent,
    NarudzbeComponent,
    UredjajiComponent,
    SignalniLagerComponent,
    RokovitrajanjaComponent,
    OtpremnicaComponent,
    WebappComponent,
    RadniNaloziDokumentiComponent,
    PregledIzdatniceTrosakComponent,
    PregledIzdatnicePotrosnogMaterijalaComponent,
    UfeComponent,
    UfaComponent,
    DigitalnaPlocaComponent,
    PregledReversComponent,
    MeduskladisnicaComponent,
    MeduskladisnicaMrviceComponent,
    KarticaArtiklaComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    SideNavOuterToolbarModule,
    SideNavInnerToolbarModule,
    SingleCardModule,
    FooterModule,
    LoginFormModule,
    AppRoutingModule,
    DxSchedulerModule,
    DxTemplateModule,
    DxDataGridModule,
    DxSelectBoxModule,
    DxCheckBoxModule,
    DxTextBoxModule,
    DevExtremeModule,
    DxButtonModule,
    DxPopupModule,
    DxNumberBoxModule,
    DxDateBoxModule,
    DxTagBoxModule,
    DxTextAreaModule,
    DxContextMenuModule,
    DxoPositionModule,
    DxScrollViewModule,
    DxRadioGroupModule,
    DxCalendarModule,
    DxDropDownBoxModule,
    DxFormModule,
    DxTabsModule,
    DxLookupModule,
    DxFileUploaderModule,
    DxTreeListModule,
    DxPopoverModule,
    DxLoadPanelModule,
  ],
  providers: [
    AuthService,
    ScreenService,
    AppInfoService,
    PdfZaOtpremniceService,
    PdfZaOtpremnicePekarTomoService,
    PdfZaDostavniceService,
    PdfZaPrimkeService,
    PrintService
  ],
  bootstrap: [AppComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class AppModule {}
